import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useSelector } from 'react-redux';
import CLabel from '../../../Common/CLabel';
import { useGetContractsPropsMaintainer, useGetPropsMaintainer } from '../../../../hooks/services/sBook/useOfContract';
import moment from 'moment';
import { isNullUndefinedOrEmpty } from '../../../../common/Helpers';
import i18next from 'i18next';

const SidePanelContractInformation = (props) => {
    const { t } = useTranslation();

    const {
        _contractPresentation: contractPresentation,
    } = useSelector((state) => state.contractPartiesState);

    const { _contractProps: listContractsProps } = useSelector((state) => state.maintainerScope);
    const { _contractPropListValues: listContractsPropValues } = useSelector((state) => state.maintainerScope);

    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

    useGetContractsPropsMaintainer(listContractsProps);
    useGetPropsMaintainer(listContractsPropValues);

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div className='d-flex'>
            <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
        </div> 
    };

    const getCustomProp = (listPropValues, column) => {
        let object = null;
        
        if (column.valType === "str") {
            object = { text: column.name, value: contractPresentation.item_contrato.l_props.find(x => x.contractPropId === column.id).strVal };
        }
        else if (column.valType === "num") {
            object = { text: column.name, value: contractPresentation.item_contrato.l_props.find(x => x.contractPropId === column.id).numVal };
        }
        else if (column.valType === "list") {
            const contractPropItem = contractPresentation.item_contrato.l_props.find(x => x.contractPropId === column.id);
            const aux_contractPropListItem = listPropValues.filter(x => x.contractPropId === column.id);
            const contractPropValueItem = contractPropItem ? aux_contractPropListItem.find(y => y.id === contractPropItem.cplId) : null;

            object = { text: column.name, value: contractPropValueItem ? contractPropValueItem.text : null };
        }
        else {
            object = { text: column.name, value: contractPresentation.item_contrato.l_props.find(x => x.contractPropId === column.id).strVal };
        }
    
        return <CLabel labelText={object.text} labelValue={object.value} />;
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-contractinformation') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <>
                {
                    (contractPresentation) &&
                    <>                          
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-code')} labelValue={contractPresentation.item_contrato.contractCode} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-name')} labelValue={contractPresentation.item_contrato.name} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">

                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-legalentitybuyername')} labelValue={contractPresentation.item_contrato.legalEntityBuyerName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-legalentitysuppliername')} labelValue={contractPresentation.item_contrato.legalEntitySupplierName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-businessunitName')} labelValue={contractPresentation.item_contrato.businessUnitName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-segmentname')} labelValue={contractPresentation.item_contrato.segmentName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-category')} labelValue={contractPresentation.item_contrato.categoryName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-currencyname')} labelValue={contractPresentation.item_contrato.currencyName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-adminuser')} labelValue={contractPresentation.item_contrato.adminUsername} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-startdate')} labelValue={moment(contractPresentation.item_contrato.startDate).format('DD/MM/YYYY')} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-enddate')} labelValue={moment(contractPresentation.item_contrato.endDate).format('DD/MM/YYYY')} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-amount')} labelValue={contractPresentation.item_contrato.amount && parseFloat(contractPresentation.item_contrato.amount.toFixed(2)).toLocaleString(i18next.language)} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-endowment')} labelValue={contractPresentation.item_contrato.endowment} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-scope')} labelValue={contractPresentation.item_contrato.scope} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-contractstatus')} labelValue={contractPresentation.item_contrato.statusName} linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col xl={12}>
                                <CLabel labelText={t('data-lang-lbl-itemstatus')} labelValue={!isNullUndefinedOrEmpty(contractPresentation.estado_partida_abierta)? (contractPresentation.estado_partida_abierta === true ? t('data-lang-lbl-openparties') : t('data-lang-lbl-closedparties')) : t('data-lang-lbl-nodata') } linked={false} linkedIconProps={null} linkedEventFire={null} linkedEventParam={null}/>
                            </Col>
                        </Row>
                        {
                            contractPresentation && contractPresentation.item_contrato && contractPresentation.item_contrato.l_props && listContractsPropValues && listContractsProps && listContractsProps.filter(x => x.deactivate === false).map(obj => 
                                <Row className="pt-3">
                                    <Col xl={12}>
                                        {getCustomProp(listContractsPropValues, obj)}
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
                </>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelContractInformation;